import { App } from "./app/App";

const canvas = document.getElementById("stage") as HTMLCanvasElement | null;
if (!canvas) throw new Error("#stage canvas missing");

new App(canvas);
